<app-skill-builder-text-list
	[mainTitle]="data.idea"
	[subTitle]="page.subtitle"
	[textInputs]="reasons"
	[next]="next"
	[validationError]="page.errorMinimum"
	[parentLoaded]="loaded.toPromise()"
></app-skill-builder-text-list>
